import bambra from "./bambra";
import harem from "./harem";
import pinkPalace from "./pinkpalace";

export const venues = [bambra, harem, pinkPalace];

export const getVenue = (slug) => venues.find((v) => v.slug === slug);

export default venues;
